import React from "react"
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material"
import { useFormikContext } from "formik"
import i18n from "@/i18n"
import { getNoShowOptions } from "@/constants/reservation_rules"
import { SETTINGS_SECTION_STYLES } from "@/components/settings/_styles"

const STYLES = {
  ...SETTINGS_SECTION_STYLES,
} as const

const NoShowPolicy: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<any>()

  const noShowOptions = getNoShowOptions()

  return (
    <div className={STYLES.container} data-testid="settings-venue-rules-no-show-container">
      <h2 className={STYLES.header}>{i18n.t("app.settings.venues.reservation_rules.no_show.title")}</h2>
      <FormControl fullWidth>
        <InputLabel id="auto-cancel-label">
          {i18n.t("app.settings.venues.reservation_rules.fields.auto_cancel_after")}
        </InputLabel>
        <Select
          labelId="auto-cancel-label"
          label={i18n.t("app.settings.venues.reservation_rules.fields.auto_cancel_after")}
          value={values.autoCancelAfter}
          onChange={(e) => setFieldValue("autoCancelAfter", e.target.value)}
          data-testid="settings-venue-rules-no-show-select"
        >
          {noShowOptions.map((o) => (
            <MenuItem key={o.value ?? "never"} value={o.value}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default NoShowPolicy
